import gql from 'graphql-tag';
import { PageInfoFragment } from '@/apolloConst/fragments';

const ExtraPayments = gql`
query ExtraPayments(
  $orderNumber: String,
  $statuses: [ExtraPaymentStatus!],
  $createdAtMin: Int,
  $createdAtMax: Int,
  $pageNo: Int,
  $maxResultsPerPage: Int
) {
  extraPayments(
    filter: {orderNumber: $orderNumber, statuses: $statuses, createdAtMin: $createdAtMin, createdAtMax: $createdAtMax},
    sorting: [{field: createdAt, direction: desc}],
    page: {pageNo: $pageNo, maxResultsPerPage: $maxResultsPerPage}
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    results {
      id
      status
      title
      description
      order {
        id
      }
      amount
      moneybackAmount
      currency {
        code
      }
      createdAt
    }
  }
}

${PageInfoFragment}
`;

export default ExtraPayments;



// WEBPACK FOOTER //
// ./src/views/ExtraPayment/graphql/ExtraPayments.js